import { useRef, useState } from 'react';

interface UseSearchBarParams {
  initialLocationSearch?: string;
}

export function useSearchBar({
  initialLocationSearch = '',
}: UseSearchBarParams = {}) {
  // Popover state
  const [openJobPopover, setOpenJobPopover] = useState(false);
  const [openLocationPopover, setOpenLocationPopover] = useState(false);

  // Input state
  const [jobSearch, setJobSearch] = useState('');
  const [locationSearch, setLocationSearch] = useState(initialLocationSearch);

  // Refs
  const jobInputRef = useRef<HTMLInputElement>(null);
  const locationInputRef = useRef<HTMLInputElement>(null);

  // Loading state
  const [isLoading, setIsLoading] = useState(true);

  return {
    // Popovers
    openJobPopover,
    setOpenJobPopover,
    openLocationPopover,
    setOpenLocationPopover,

    // Inputs
    jobSearch,
    setJobSearch,
    locationSearch,
    setLocationSearch,

    // Refs
    jobInputRef,
    locationInputRef,

    // Loading
    isLoading,
    setIsLoading,
  };
}
